

/* eslint-disable class-methods-use-this */
import { CourseApplicationRes, EachCourseApplicationRes } from '../models/course-application.model';
import { ICourseEnrol, ICourseTrainers, IGetEnrolmentRes, IGetEnrolmentPaymentRes } from '../models/course-enrolment.model';
import getService from './getService';
import postService from './postService';

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://20.126.75.78/naptin/api/v1/';

const COURSEENROL = 'courses/';
const GETCOURSEENROLMENT = 'users/'
const GETCOURSEAPPLICATION ='course-applications'
const APPROVE_DECLINE_COURSE ='course-applications/approve'
const GETEACHENROLLEDCOURSE ='course-enrollments/'
const TRAINERCOURSES = 'courses/{uuid}/trainers'

class CourseEnrolServices {
  
  async getEnroledCourses(uuid: string) {
    const response  = await getService.get(
      `${CONFIG_API_URL}${GETCOURSEENROLMENT}${uuid}/courses-enrolled`
    );
    const res :IGetEnrolmentRes = response.data
    return res;
  }


  async getAvailableResults(user_uuid: string) {
    const response  = await getService.get(
      `${CONFIG_API_URL}users/${user_uuid}/get-available-results`
    );
    const res :any = response.data
    return res;
  }

  
  async getPendingPayment(uuid: string) {
    const response  = await getService.get(
      `${CONFIG_API_URL}${GETCOURSEENROLMENT}${uuid}/courses-enrolled-payment`
    );
    const res :IGetEnrolmentPaymentRes = response.data
    return res;
  }


  async getTraineeEnroledCoursesByAdmin(uuid: string) {
    const response  = await getService.get(
      `${CONFIG_API_URL}admin/trainees/${uuid}/courses-enrolled`
    );
    const res :IGetEnrolmentRes = response.data
    return res;
  }
  //admin/trainees/{uuid}/courses-enrolled
  async getEachEnroledCourse(uuid: string | undefined) {
    const response  = await getService.get(
      `${CONFIG_API_URL}${GETEACHENROLLEDCOURSE}${uuid}`
    );
    const res :any = response.data
    return res;
  }
  async getCourseApplications() {
    const response  = await getService.get(
      `${CONFIG_API_URL}${GETCOURSEAPPLICATION}`
    );
    const res :CourseApplicationRes = response.data
    
    return res;
  }
  async getEachApplication(uuid: string | undefined) {
    const response  = await getService.get(
      `${CONFIG_API_URL}${GETCOURSEAPPLICATION}/${uuid}`
    );
    const res :EachCourseApplicationRes = response.data
    
    return res;
  }

  async enrolCourse(data: ICourseEnrol, uuid: string | undefined) {
    const response = await postService.post(`${CONFIG_API_URL}${COURSEENROL}${uuid}/enroll`, data);
    if (response.data.token && response.data.user) {
 
    }
    return response.data;
  }

  async applyForProgram(data: ICourseEnrol, uuid: string) {
    const response = await postService.post(`${CONFIG_API_URL}courses/${uuid}/apply`, data);
    return response.data;
  }

  async approve_decline_course(data: any) {
    const response = await postService.post(`${CONFIG_API_URL}${APPROVE_DECLINE_COURSE}`, data);
    if (response.data.token && response.data.user) {
 
    }
    return response.data;
  }

  async getCourseTrainers() {
    const response = await getService.get(`${CONFIG_API_URL}${TRAINERCOURSES}`)
    const res :ICourseTrainers = response.data
    return res;
  }
 
}

export default new CourseEnrolServices();
